export default "__VITE_ASSET__DiduMyn1__"